import React from 'react';
import PropTypes from 'prop-types';
import Roulette from 'components/Roulette';


const PopupCouponRoulette = ({ execActionConfirm = null }) => {
    
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    }
    

    return (
        <div id="message-popup-terms" className="white-popup message-popup-simple">
            
            <div className="container">
                <div className="row">

                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>Ruleta de Cupones</strong>
                                </p>
                                <Roulette slices={6}/>

                              
                                <div className="text-center">
                                    <a href="#" onClick={(event) => handleConfirm(event)} className="btn">
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
        
    )
};

PopupCouponRoulette.propTypes = {
    execActionConfirm: PropTypes.func, 
   
};
export default PopupCouponRoulette;
